<template>
  <div class="overview standard_home_page" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <el-tabs v-model="topLeft">
      <el-tab-pane name="0" disabled>
        <span slot="label">总览</span>
        <el-tooltip slot="label" class="item" effect="light" placement="right">
          <div slot="content">
            呼入总量：客户呼入数量（如客户呼入只到IVR也算，但需要确认这个热线号码是在呼叫中心上所配置的）<br/>
            转人工量：统计只要进了技能组的电话数就算转人工，针对呼入及自动呼出的数据<br/>
            转人工接通量：客户与座席接通的数量，针对客户呼入、自动呼出的数据 <br/>
            转人工接通率：转人工接通量/转人工量<br/>
            呼出总量：手动呼出及自动呼出数量<br/>
            呼出接通量：客户接通的数量，针对手动呼出、自动呼出的数据<br/>
            呼出接通率：呼出接通量/呼出量<br/>
            转满意度量：转满意度的数量，针对客户呼入、手动呼出、自动呼出的数据<br/>
            好评率：(非常满意+满意)/转满意度量<br/>
            平均通话时长：客户与座席的通话时长/(转人工接通量+手动呼出接通量)<br/>
            平均排队时长：(座席接听时间点-客户进技能组时间点)/转人工接通量。
          </div>
          <img :src="questionMark"/>
        </el-tooltip>
      </el-tab-pane>
      <el-tab-pane>
        <el-select slot="label" v-model="autoRefreshTime" placeholder="自动刷新时间" title="自动刷新时间" @change="autoRefreshMonitor">
          <el-option v-for="item in autoRefreshList" :key="item.time" :label="item.name" :value="item.time"></el-option>
        </el-select>
      </el-tab-pane>
      <el-tab-pane>
        <span style="color: red;" slot="label" title="刷新倒计时">{{countdownTime}}</span>
      </el-tab-pane>
    </el-tabs>
    <div class="left":style="tableHeight">
      <div class="topLeft_left">
        <div style="width: 60%">呼入总量</div>
        <div style="width: 20%;color: #2c92ba">{{callinCount}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_right">
        <div style="width: 60%">呼出接通量</div>
        <div style="width: 20%;color: #ef914b">{{calloutAnswer}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_left">
        <div style="width: 60%">呼出总量</div>
        <div style="width: 20%;color: #2c92ba">{{calloutCount}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_right">
        <div style="width: 60%">转人工接通量</div>
        <div style="width: 20%;color: #ef914b">{{turnPeopleAnswer}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_left">
        <div style="width: 60%">转人工量</div>
        <div style="width: 20%;color: #2c92ba">{{turnPeople}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_right">
        <div style="width: 60%">平均通话时长</div>
        <div style="width: 20%;color: #ef914b">{{callDurationAverage}}</div>
        <div style="width: 20%">秒</div>
      </div>
      <div class="topLeft_left">
        <div style="width: 60%">转满意度</div>
        <div style="width: 20%;color: #2c92ba">{{turnSatisfied}}</div>
        <div style="width: 20%">通</div>
      </div>
      <div class="topLeft_right">
        <div style="width: 60%">平均排队时长</div>
        <div style="width: 20%;color: #ef914b">{{lineUpAverage}}</div>
        <div style="width: 20%">秒</div>
      </div>
    </div>
    <div class="right" :style="tableHeight">
      <div id="customerTotal" class="customer_total" style="width: 100%;height: 100%"></div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "Overview",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        topLeft:'1',
        Interval:'0',
        callinCount:"0",
        calloutAnswer:"0",
        calloutCount:"0",
        turnPeopleAnswer:"0",
        turnPeople:"0",
        callDurationAverage:"0",
        turnSatisfied:"0",
        lineUpAverage:"0",
        questionMark:require('../../assets/image/homeAsk.png'),
        refresh:require('../../assets/image/refresh.png'),
        spinShow: false,
        screenHeight:{height:''},
        tableHeight:{height:''},
        stateList:[],
        countdownTime:0,
      }
    },
    methods: {
      autoRefresh:function () {
        let param={
          journalType:"null",
          menuId:"null",
          createTime:this.getSearchTime('1')
        };
        let that=this;
        this.$http.post("home/callAllCount.json",param) .then(function (res) {//查询话务统计
          let result=res.data.flag;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          let list=res.data.obj.list;
          if(list && list.length>0){
            that.callinCount=list[0].callinCount;
            that.calloutAnswer=list[0].calloutAnswer;
            that.calloutCount=list[0].calloutCount;
            that.turnPeopleAnswer=list[0].turnPeopleAnswer;
            that.turnPeople=list[0].turnPeople;
            that.callDurationAverage=list[0].callDurationAverage;
            that.turnSatisfied=list[0].turnSatisfied;
            that.lineUpAverage=list[0].lineUpAverage;
          }
        });
        let paramTwo={
          journalType:"null",
          menuId:"null",
        };
        that.$http.post("popUp/statisticsAgentStatus.json",paramTwo) .then(function (res) {//查询座席状态
          let result=res.data.flag;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          if(res.data.obj){
            that.stateList=res.data.obj;
          }
          let customerTotal = that.$echarts.init(document.getElementById('customerTotal'));
          customerTotal.setOption({
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left:2,
              data: ['空闲', '忙碌', '通话', '离线', '其他'],
              textStyle: {
                fontSize: 18
              }
            },
            color : [ '#add597', '#79c6d8', '#1e7ca0', '#dbdd00', '#f19049'],
            graphic:{
              type:"text",
              left:"center",
              top:"center",
              cursor:'default',
              style:{
                text:"座席状态\n统计",
                textAlign:"center",
                fill:"#262829",
                fontSize:20
              }
            },
            series: [
              {
                name: '座席状态统计',
                type: 'pie',
                radius: ['40%', '60%'],
                avoidLabelOverlap: true,
                label: {
                  show: true,
                  position: 'left',
                  normal: {
                    show: true,
                    formatter: '{b}\n{c}   {d}%',
                    position: 'outside',
                    fontSize: '20',
                  }
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '20',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: true,
                  normal:{
                    length:20
                  }
                },
                data: that.stateList,
              }
            ]
          });
        });
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(92);
      this.tableHeight.height=this.mountHeight(142);
    },
    destroyed(){
      this.autoRefreshTime='0';
      clearInterval(this.Interval);
      this.autoRefreshMonitor();
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='7_2-2' && this.showPageCount==0){
          this.showPageCount++;
          this.autoRefresh();
        }
        if(this.pageCode=='7_2-2'){
          this.autoRefreshTime=this.historyRefreshTime;
          this.autoRefreshMonitor();
        }
        if(this.pageCode!='7_2-2'){
          clearInterval(this.Interval);
          this.autoRefreshTime="0";
          this.countdownTime="0";
        }
      }
    }
  }
</script>

<style  lang="less">
  .demo-split{
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .week{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
  .day{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
  .month{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
</style>



// WEBPACK FOOTER //
// src/components/MonitorManage/Overview.vue